'use strict';

export default class TopPanel {
  constructor($rootScope, $timeout, $compile, $animate, $window, $document, scrollTop, navigation) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.$compile = $compile;
    this.$animate = $animate;
    this.scrollTop = scrollTop;
    this.navigation = navigation;

    this.window = angular.element($window);

    let document = $document[0];
    this.body = angular.element(document.body);
    this.wrapperEl = angular.element(document.querySelector('.Wrapper'));
  }

  _getTransform(offset) {
    var styles = {};

    styles['-webkit-transform'] = '';
    styles['transform'] = '';
    if (offset) {
      styles['-webkit-transform'] = `translate(0, ${offset}px)`;
      styles['transform'] = `translate(0, ${offset}px)`;
    }


    return styles;
  }

  open(template) {
    if (this.panel || this.isAnimating) {
      this.scrollTop(0);
      return;
    }

    // Add panel to DOM
    let panel = angular.element(`<sa-top-panel>${template}</sa-top-panel>`);
    this.body.append(panel);
    this.$compile(panel)(this.$rootScope.$new());

    let panelHeight = panel[0].offsetHeight;

    // Prepare for animation
    this.navigation.disable();
    this.isAnimating = true;
    this.wrapperEl.addClass('animate-transform is-ngAnimationEnabled');

    this.$animate.animate(this.wrapperEl, {}, this._getTransform(panelHeight))
      .then(() => {
        this.scrollTop(0);

        this._scrollHandler = this._scrollHandler.bind(this);
        this.window.on('scroll', this._scrollHandler);
        this.panel.on('$destroy', () => this.window.off('scroll', this._scrollHandler));

        this.unbindEventListener = this.$rootScope.$on('$stateChangeSuccess', this.close.bind(this));
      })
      .finally(() => {
        this.wrapperEl.removeClass('animate-transform is-ngAnimationEnabled');
        delete this.isAnimating;
      });

    this.panel = panel;
    this.panelHeight = panelHeight;
  }

  close(animated) {
    if (!this.panel || this.isAnimating) {
      return;
    }

    if (animated === true) {
      this.wrapperEl.addClass('animate-transform is-ngAnimationEnabled');
      this.$animate.animate(this.wrapperEl, {}, this._getTransform(0))
        .then(this._afterClose.bind(this));
    } else {
      this.wrapperEl.css(this._getTransform(0));
      this._afterClose();
    }
  }

  _afterClose() {
    this.scrollTop(Math.max(this.scrollTop() - this.panelHeight, 0));

    this.$timeout.cancel(this._timeoutPromise);
    this.window.off('scroll', this._scrollHandler);

    this.navigation.enable();
    this.panel.remove();
    this.wrapperEl.removeClass('animate-transform is-ngAnimationEnabled');

    delete this.isAnimating;
    delete this.panelHeight;
    delete this.panel;
    this.unbindEventListener();
  }

  _scrollHandler() {

    // Stop listening to scroll event
    this.window.off('scroll', this._scrollHandler);

    // Start waiting for scroll to end
    this._waitAndClose();
  }

  _waitAndClose() {
    this._lastScrollTop = this.scrollTop();
    this._timeoutPromise = this.$timeout(() => {
      let scrollTop = this.scrollTop();

      // User stopped scrolling!
      if (this._lastScrollTop === scrollTop) {

        if (this.scrollTop() >= this.panelHeight) {
          this.close();
        } else {
          this.window.on('scroll', this._scrollHandler);
        }

      } else {
        this._waitAndClose();
      }
    }, 80);
  }
}



// WEBPACK FOOTER //
// ./app/src/common/top_panel/top_panel.service.js